import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef, ViewChild, ComponentRef, NgZone } from '@angular/core';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { RolePermissionService } from 'src/modules/base/shared/services/role-permission.service';
import { DialogService } from '../../../dialog/dialog.service';
import { DialogModalSize } from '../../../dialog/dialog-ref';
import { AIService } from '../../services/ai.service';
import { KxAISpeechComponent } from '../kx-ai-speech/kx-ai-speech.component';
import { FloatingOverlayService } from '../../../floating-host/floating-overlay.service';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-kx-ai-filling',
    templateUrl: './kx-ai-filling.component.html',
    styleUrls: ['./kx-ai-filling.component.scss'],
    standalone: false
})
export class KxAIFillingComponent implements OnInit {
  @Input() config:any;
  // id of a page element the minimized (floating) AI transcription widget should start over; still draggable
  @Input() initialPositionTargetId?: string;
  // CSS selector of the page area the widget may be dragged within (whole viewport if unset)
  @Input() dragBoundsSelector?: string;
  private stopFollowingPositionTarget?: () => void;
  private _aiConfig: any;
  @Input()
  set aiConfig(value: any) {
    this._aiConfig = value;
    this.syncAiConfig();
  }
  get aiConfig() {
    return this._aiConfig;
  }
  @Output() getData = new Subject<any>();
  public data:any = {isAvailable:false,voiceFill:false,scanFill:false,formConfig:{},notFound:{},showAIButton:true,subscription:false,speechCompRef:true};
  @ViewChild('customComponent', { read: ViewContainerRef }) customComponent: ViewContainerRef;
  private floatingRef: any;

  constructor(
    public rolePermissionService:RolePermissionService,
    public baseService:BaseService,
    public aiService:AIService,
    public alertService:AlertsService,
    public dialogService: DialogService,
    public loader:LoaderService,
    private floating: FloatingOverlayService,
    private ngZone: NgZone
  ) {    
  
   
  }

  ngOnInit() {
    console.log(this.config)
    // #aside-modal-container is the aside bar's own stable DOM id, reused across whichever
    // resource is currently loaded inside it — marking it here (rather than threading an
    // @Input() down through the aside's dynamically-injected content) matches how
    // AsideBarService itself already toggles classes on it directly.
    if (this.config?.resource_config?.ai?.form?.floating_position === 'top-right') {
      document.getElementById('aside-modal-container')?.classList.add('ai-agent-open');
    }
    if (this.config?.resource_config != undefined && this.config?.resource_config?.ai != undefined && this.config?.resource_config?.ai?.form != undefined) {
      this.data.formConfig = this.config?.resource_config?.ai?.form;
      var isAvailable = this.rolePermissionService.checkIfEnabled(AIService.ENABEL_AI)
      if (isAvailable) {
        this.aiService.checkIfAIAvailable({ resource: this.config?.resource }, this.data.formConfig.feature, (respData) => {
          console.log(respData);
          if (respData) {
          var promptObj = {};
          for (let index = 0; index < respData.length; index++) {
            const element = respData[index];
            promptObj[element.ai_feature_code] = element
          }
          this.data.scanFill = promptObj[AIService.SCAN_FILL] != undefined && (this.aiService.checkFeatureEnabledinJson(this.data.formConfig, AIService.SCAN_FILL) && this.aiService.checkIfFeatureAvailable({ai_agent:promptObj[AIService.SCAN_FILL].ai_agent, feature: AIService.SCAN_FILL, resource: this.config?.resource }))

          this.data.scanFillObj = promptObj[AIService.SCAN_FILL] != undefined ?promptObj[AIService.SCAN_FILL]:false


          this.data.voiceFill = promptObj[AIService.VOICE_FILL] != undefined && (this.aiService.checkFeatureEnabledinJson(this.data.formConfig, AIService.VOICE_FILL) && this.aiService.checkIfFeatureAvailable({ai_agent:promptObj[AIService.VOICE_FILL].ai_agent, feature: AIService.VOICE_FILL, resource: this.config?.resource }))

          this.data.voiceFillObj = promptObj[AIService.VOICE_FILL] != undefined ?promptObj[AIService.VOICE_FILL]:false
          this.data.isAvailable = this.data.scanFill || this.data.voiceFill;
          this.createSpeechComponent()
        }

        }, false)
      }


    }
  }

  textToSpeech() {
    this.data.notFound = {}
   
    if(this.config.loading){
      return true;
    }
    let popobj = { data: this.data,config:this.config,aiConfig:this.aiConfig, size: DialogModalSize.Md };
    //this.getOptions(this.data.schema,this.config?.formService?.questionMapping);
    this.config.popupModel = this.dialogService.open(KxAISpeechComponent, popobj);
      this.config.popupModel.afterClosed.subscribe(response => {
        if(response){
               
        }
        delete this.config.popupModel;
         
    });
  }

  

 

  getOptions(fieldList,questionMapping){
    for(let key in fieldList){
      var field = fieldList[key];
      var fieldName = field.name || field.key;
      if(Array.isArray(field) && field.length>0){
        fieldName = key;//composite array
      }
      
      if(questionMapping[fieldName] != undefined){
        var question = questionMapping[fieldName]
        if(question?.controlType == "composite-array"){
          //TODO loop through question
          if(this.config.formService?.compositeQuestionMapping[question.key] != undefined){
            var questionList = this.config.formService?.compositeQuestionMapping[question.key];
            var fieldList = field[0]
            this.getOptions(fieldList,questionList);
          }
          
        }else{
          this.getFieldOptions(field,question)
        }
      }      
    }
  }

  getFieldOptions(field,question){
      if(["dropdown","searchselect"].indexOf(question.controlType) > -1 && question.options != undefined && Array.isArray(question.options) && question.options.length>0){
        field.options = question.options
      }
  }

  createSpeechComponent(){
    if(this.config?.resource_config?.ai?.form?.minimized != undefined && this.config?.resource_config?.ai?.form?.minimized && (!this.data.scanFill && this.data.voiceFill)){
      let popobj = { data: this.data,config:this.config,aiConfig:this.aiConfig, size: DialogModalSize.Sm };
      this.createComponent(this.customComponent,'app-kx-ai-speech',popobj,(compObj)=>{
        this.config.speechCompRef = compObj
        compObj.dialogConfig = popobj
        compObj.config.minimized = true
        compObj.config.isTranscriptionExpanded = false;
        this.data.showAIButton = false
        if(this.config?.resource_config?.ai?.form?.continous_transcription != undefined){
          compObj.config.continousTranscription = this.config?.resource_config?.ai?.form?.continous_transcription;
        }
    
        if(this.config?.resource_config?.ai?.form?.interval_transcription != undefined){
          compObj.config.intervalTranscription = this.config?.resource_config?.ai?.form?.interval_transcription;
        }
        
        this.config.subscription = compObj.getData.subscribe((eventData: any) => {
          console.log('Event received:', eventData);
          this.getData.next({"type":"ai_prescription","data":eventData})
        });
        this.syncAiConfig();
      });
    }    
  }

  private syncAiConfig() {
    if (this.config?.speechCompRef?.dialogConfig) {
      this.config.speechCompRef.dialogConfig.aiConfig = this.aiConfig;
    }
  }
  createComponent(
    comp: ViewContainerRef,
    kxselector: any,
    input: any,
    callback: (instance: any) => void
  ) {
    const floatingOptions: any = {};
    if (this.dragBoundsSelector) {
      floatingOptions.boundsSelector = this.dragBoundsSelector;
    }
    const positionTarget = this.initialPositionTargetId ? document.getElementById(this.initialPositionTargetId) : null;
    if (positionTarget) {
      const rect = positionTarget.getBoundingClientRect();
      floatingOptions.left = Math.round(rect.left);
      floatingOptions.top = Math.round(rect.top);
    } else if (this.config?.resource_config?.ai?.form?.floating_position === 'top-right') {
      floatingOptions.corner = 'top-right';
    }
    this.floating.createWithFactory<any>((container) => {
      container.clear();
    }, floatingOptions).then((floatingRef) => {
      this.floatingRef = floatingRef;
  
      const vc = floatingRef.container;
      if (!vc) {
        console.error('FloatingOverlayService returned no container');
        return;
      }
  
      this.aiService.createComponent(vc, kxselector, input, (response: any) => {
        if (!response) return;
        try { floatingRef.contentRef = response as ComponentRef<any>; } catch (e) { /* ignore */ }
  
        callback(response.instance);
      });

      if (positionTarget) {
        this.followPositionTarget(floatingRef);
      }

    }).catch((err) => {
      console.error('Error creating floating component:', err);
    });
  }

  // The page layout keeps shifting after the widget is created (side menu collapsing, content
  // loading, scrolling), which would leave the fixed-position widget behind. Keep it lined up
  // with its start container until the user drags it somewhere else.
  private followPositionTarget(floatingRef: any) {
    const el = floatingRef.hostRef.instance.rootRef.nativeElement as HTMLElement;
    const align = () => {
      const target = document.getElementById(this.initialPositionTargetId);
      if (!target) return;
      const rect = target.getBoundingClientRect();
      floatingRef.setPosition(Math.round(rect.left), Math.round(rect.top));
    };
    this.ngZone.runOutsideAngular(() => {
      const target = document.getElementById(this.initialPositionTargetId);
      const resizeObserver = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(align) : null;
      if (target) resizeObserver?.observe(target);
      window.addEventListener('scroll', align, true);
      window.addEventListener('resize', align);
      const stopFollowing = () => this.stopFollowingPositionTarget?.();
      const dragHandle = el.querySelector('.kx-floating-drag-handle');
      dragHandle?.addEventListener('pointerdown', stopFollowing);
      this.stopFollowingPositionTarget = () => {
        resizeObserver?.disconnect();
        window.removeEventListener('scroll', align, true);
        window.removeEventListener('resize', align);
        dragHandle?.removeEventListener('pointerdown', stopFollowing);
        this.stopFollowingPositionTarget = undefined;
      };
    });
    align();
  }

  ngOnDestroy(){
    this.stopFollowingPositionTarget?.();
    // Remove the marker so it doesn't leak onto whatever resource loads into this same
    // aside container next.
    document.getElementById('aside-modal-container')?.classList.remove('ai-agent-open');
    if(this.config.subscription){
      this.config.subscription.unsubscribe();
    }
    if (this.floatingRef) {
      try { this.floatingRef.destroy(); } catch (e) { /* ignore */ }
      this.floatingRef = null;
    }
  }
  

}
